import { DateFilterName, FilterName, StringFilterName } from "./types";

export function isDateFilterName(name: FilterName): name is DateFilterName {
  return ["createdDate", "treatedMerchantDate", "treatedLogisticianDate"].includes(name);
}

export function isStringFilterName(name: FilterName): name is StringFilterName {
  return ["status", "resolution", "reason", "assignee", "returnStore"].includes(
    name,
  );
}
